import PropTypes from 'prop-types';
const getSearchValues = ({ searchParameters, slug, type }) => {

  if (type === 'int' || type === 'float') {
    return {
      min: searchParameters?.[`${slug}_min`]||searchParameters?.[slug]?.[0], max: searchParameters?.[`${slug}_max`]||searchParameters?.[slug]?.[1]
    };
  } else {
    const defaultForType={
      'bool':null,
      'name':[],
      'names':[],
      'term':[],
    };
    
    return searchParameters?.[slug]||defaultForType[type];
  }
};
getSearchValues.propTypes={
  searchParameters:PropTypes.shape({}),
  type:PropTypes.oneOf(['stars','name','names','term','int','float','bool']).isRequired,
  slug:PropTypes.string.isRequired,
};
export default getSearchValues;
